export const ALLOWED_FILES =
  '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf'

export const RESUME_MAX_SIZE = 1000000 // 10 MB
export const IMAGE_FILE_REGEX = /image\/(jpe?g|png|gif)/
